export function eventRange(days, now = new Date()) {
  const turkey = new Date(now.getTime() + 3 * 60 * 60 * 1000)
  const today = turkey.toISOString().slice(0, 10)
  turkey.setUTCDate(turkey.getUTCDate() - days + 1)

  return { from: `${turkey.toISOString().slice(0, 10)}T00:00`, to: `${today}T23:59` }
}

export function eventParams(filters) {
  return Object.fromEntries(Object.entries(filters).filter(([key, value]) => (typeof value === 'string' && value.trim() !== '') || (['exactEvent', 'exactScreen'].includes(key) && value === true)).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value]))
}

export function screenLabel(name) {
  const labels = {
    revamp_explore: 'Keşfet',
    revamp_links: 'Linklerim',
    revamp_create_link: 'Link oluştur',
    revamp_wallet: 'Cüzdan',
    revamp_profile: 'Profil',
    revamp_points: 'Puan',
    revamp_link_detail: 'Link detayı',
    revamp_offer_detail: 'Marka / offer detayı',
    revamp_campaign_detail: 'Kampanya detayı',
    revamp_interests: 'Kitle ilgi alanları',
    revamp_withdraw: 'Para çekme',
    revamp_notifications: 'Bildirimler',
    revamp_points_convert: 'Puan çevirme',
    revamp_points_break: 'Puan bozma',
    revamp_points_detail: 'Puan detayı',
    revamp_wallet_transactions: 'Cüzdan işlemleri',
    revamp_subscriptions: 'Premium',
    revamp_invoice_info: 'Fatura bilgileri',
    revamp_notification_settings: 'Bildirim ayarları',
    revamp_personal_info: 'Kişisel bilgiler',
  }

  return labels[name] || (name && name !== '(not set)' ? name : 'Ekran belirtilmemiş')
}

export function validateEventRange(filters) {
  const from = new Date(`${filters.from}+03:00`)
  const to = new Date(`${filters.to}+03:00`)
  if (!filters.from || !filters.to || Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 'Geçerli başlangıç ve bitiş tarihi seçin.'
  if (from >= to) return 'Başlangıç, bitiş tarihinden önce olmalı.'
  if ((to - from) / 86400000 > 366) return 'Tek raporda en fazla 366 gün seçebilirsiniz.'
  if (from > new Date()) return 'Başlangıç tarihi gelecekte olamaz.'

  return ''
}

export function eventProperties(event) {
  const value = event?.propertiesJson || event?.properties || {}
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value

    return parsed && typeof parsed === 'object' ? parsed : { value: parsed }
  } catch (_) { return { raw: value } }
}

export function formatEventDate(value, time = false) {
  if (!value) return '—'
  const raw = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(value) ? `${value}+03:00` : value
  const date = new Date(raw)
  if (Number.isNaN(date.getTime())) return '—'

  return new Intl.DateTimeFormat('tr-TR', { timeZone: 'Europe/Istanbul', ...(time ? { hour: '2-digit', minute: '2-digit', second: '2-digit' } : { day: '2-digit', month: '2-digit', year: 'numeric' }) }).format(date)
}
